import {UmpireCompetitionSeason} from '../umpire-competition-season';
import {UmpireSeason} from '../umpire-season';
import {UmpireGroup} from '../umpire-group';

export interface UmpireStage {
  type: 'stage';

  id: string;

  name: string;

  season: UmpireSeason;

  groups: UmpireGroup[];

  competition_season: UmpireCompetitionSeason;

  slug: string | null;
}
